@if (!initialThreadsLoading()) {
  <div class="flex h-full flex-1">
    <div class="h-full overflow-hidden border-r border-r-gray-2">
      <chat-threads-list
        [selectedThread]="chatState.selectedThread()"
        [threads]="chatState.threads()"
        [unreads]="chatState.unreads()"
        [ownUserId]="chatState.ownUserId()"
        (openThread)="onOpenThread($event)"
        (searchOutput)="chatState.onThreadSearch($event)"
        (pinThread)="chatState.pinThread($event)"
        (unpinThread)="chatState.unpinThread($event)"
      >
      </chat-threads-list>
    </div>

    @if (!!hasSelectedThread()) {
      <div class="min-w-0 flex-1">
        <chat-messages-list
          [loading]="chatState.messagesLoading()"
          [ownUserId]="chatState.ownUserId()"
          [threadUserId]="chatState.selectedThread().ownerId"
          [threadId]="chatState.selectedThread().id"
          [clientProfile]="chatState.member()"
          [messages]="chatState.messages()"
          [unreadCount]="chatState.unreads().get(chatState.selectedThread().id) || 0"
          (sendMessage)="chatState.onSendMessage($event)"
          (messagesBefore)="chatState.onMessagesBefore($event)"
          (messagesAfter)="chatState.onMessagesAfter($event)"
          (markRead)="chatState.onMessagesRead()"
        >
        </chat-messages-list>
      </div>
    }

    @if (!!chatState.member()) {
      <div class="min-w-0 flex-1">
        <chat-info-board [member]="chatState.member()"></chat-info-board>
      </div>
    }
  </div>
} @else {
  <div class="flex h-full w-full items-center justify-center">
    <shared-loader></shared-loader>
  </div>
}
